import React, { FC } from 'react';

import {
  TableContainer, Table, makeStyles, TableHead, TableRow, TableCell, TableBody, Button,
} from '@material-ui/core';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

interface FeaturedProductsEditorProps {
  catalogSpec: any,
  onUpdate: () => void,
}

const FeaturedProductsEditor: FC<FeaturedProductsEditorProps> = (props) => {
  const { catalogSpec, onUpdate } = props;
  const classes = useStyles();
  return (
    <TableContainer>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell component="th" scope="row">
              {catalogSpec.name}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              {catalogSpec.label}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              {catalogSpec.coverImageUrl}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Button onClick={() => {
                onUpdate();
              }}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default FeaturedProductsEditor;
